import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigurationService} from '../../configuration.service';
import {UrlEndpoints} from '../../../definitions/url-endpoints';
import {ActionDateQueryModel} from '../../../models/action-date-query.model';

@Injectable({
    providedIn: 'root'
})
export class ActionResourceService {

    constructor(private http: HttpClient,
                private configuration: ConfigurationService,
                private urlEndpoints: UrlEndpoints) {
    }


    getActions(actionQuery: ActionDateQueryModel) {
        return this.http.post(this.configuration.buildUrl(this.urlEndpoints.postActionsByOperatorAndDayEndPoint), actionQuery).toPromise();
    }

    getActionTypes() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.getAllActionsTypeEndPoint)).toPromise();
    }

    getActionTypesAndFrequency() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.getAllActionsTypeAndFrequencyEndPoint)).toPromise();
    }

    getActionPriorities() {
        return this.http.get(this.configuration.buildUrl(this.urlEndpoints.getAllActionsPrioritiesEndPoint)).toPromise();
    }
}
